import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-casino-acc-pin',
  templateUrl: './rg-casino-acc-pin.component.html',
  styleUrl: './rg-casino-acc-pin.component.scss'
})
export class RgCasinoAccPinComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
}
